<template>
	<div id="aboutUs">
		<div v-html="content"></div>
	</div>
</template>

<script>
import FeApiService from "@/assets/js/FeApiService";
const apiService = new FeApiService();

export default {
	data() {
		return {
			content: "",
		};
	},
	props: {
		name: {
			type: String
		},
	},
	mounted() {
		apiService
			.getPagesDetails( this.$route.params.name )
			.then(request => this.contentBlockSuccessful(request))
			.catch(err => this.contentBlockFailed(err));
	},
	methods: {
		contentBlockSuccessful(request) {
			(this.content = request.content);
		},
		contentBlockFailed(err) {
			this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
                title: err.error.response.data.title,
                autoHideDelay: 10000,
                appendToast: false,
                variant: "danger",
                solid: true
            });
		}   
	}
};
</script>